const HEIC_EXTENSION = /\.(heic|heif)$/i;

export function isHeicFile(file: File): boolean {
  return HEIC_EXTENSION.test(file.name) || file.type === "image/heic" || file.type === "image/heif";
}

export async function convertHeicToJpeg(file: File): Promise<File> {
  const { HeifDecoder } = await import("libheif-js/wasm-bundle");

  const [image] = new HeifDecoder().decode(new Uint8Array(await file.arrayBuffer()));
  if (!image) {
    throw new Error("HEIC file holds no image");
  }

  const width = image.get_width();
  const height = image.get_height();

  const decoded = await new Promise<ImageData>((resolve, reject) => {
    image.display(new ImageData(width, height), (result) => {
      if (result) {
        resolve(result);
      } else {
        reject(new Error("HEIC decoding failed"));
      }
    });
  });

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext("2d");
  if (!context) {
    throw new Error("Canvas 2d context is unavailable");
  }
  context.putImageData(decoded, 0, 0);

  const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/jpeg", 0.92));
  if (!blob) {
    throw new Error("HEIC to JPEG encoding failed");
  }

  return new File([blob], file.name.replace(HEIC_EXTENSION, ".jpg"), { type: "image/jpeg", lastModified: file.lastModified });
}

export async function convertHeicFiles(files: File[]): Promise<File[]> {
  return await Promise.all(files.map(async (file) => (isHeicFile(file) ? await convertHeicToJpeg(file) : file)));
}
